<template>
    <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-toolbar dark :color="options.color" dense flat>
        <v-toolbar-title class="text-body-2 font-weight-bold">
          {{ title }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text
        v-show="!!message"
        class="pa-4"
      ></v-card-text>
      <v-card-actions class="pt-3">
        <v-spacer></v-spacer>
        <v-btn elevation="0"
          v-if="!options.noconfirm"
          small
          @click.native="cancel"
          :color="options.cancelColor"
          >{{options.cancelText}}</v-btn
        >
        <v-btn elevation="0"
          :color="options.confirmColor"
          small
          @click.native="agree"
          >{{options.confirmText}}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default{
      name: 'ConfirmDialog',
      data: function () {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      message: null,
      title: null,
      options: {
        color: "#425058",
        width: 400,
        zIndex: 200,
        noconfirm: false,
        confirmText: 'Confirm',
        confirmColor:'success',
        cancelText:'Cancel',
        cancelColor:'error'
      }
    };
  },
  methods: {
    open(title, message, options) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    }
  }

}

</script>
